// extracted by mini-css-extract-plugin
module.exports = {"mappedAnnounces":"announcesStyles-module--mappedAnnounces--IBxz9"};